import React from "react";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import {
  CardContent,
  Grid,
  Card as MuiCard,
  LinearProgress,
} from "@mui/material";

import * as Enums from "src/utils/enums";
import useForm from "src/hooks/useForm";

import { getNextCode } from "src/services/generalService";
import { DefaultService } from "src/services/defaultService";

//import TestList from "./TestList";
import AMIndexList from "src/pages/components/AMIndexList";

const Card = styled(MuiCard)(spacing);

function Destination({ menuItemCode }) {
  const defaultService = new DefaultService("AwbDestinations");

  //#region Api Calls
  const getNextCodeFunc = async () => {
    const { data } = await getNextCode(menuItemCode, "code", "");
    return data || "";
  };

  const getByIdFunc = async (id) => {
    const { data } = await defaultService.get(menuItemCode, id);
   //Remove id if rendered from server to keep id as it comes from url and not enter in infinite loop
    //also if not remoced copy form will not work
    if (data) {
      delete data.id;
      delete data.ID;
      delete data.Id;
      delete data.iD;
    }
    return data;
  };

  const saveFormFunction = async (menuItemCode, formData) => {
    const { data } = await defaultService.save(menuItemCode, formData);
    return data;
  };

  const deleteFunction = async (menuItemCode, formData) => {
    const { data } = await defaultService.delete(menuItemCode, formData);
    return data;
  };
  //#endRegion

  const {
    state: values,
    indexColumns,
    renderFormHeader,
    renderFormInput,
    preLoaded,
  } = useForm({
    menuItemCode: menuItemCode,
    nextCodeField: "code",
    getNextCodeFunc: getNextCodeFunc,
    getByIdFunc: getByIdFunc,
    saveFunction: saveFormFunction,
    deleteFunction: deleteFunction,
  });

  if (!preLoaded) return <LinearProgress my={2} />;

  const mainData = (
    <Card mb={6}>
      <CardContent>
        <Grid container spacing={4}>
          {renderFormInput("code", "text", {
            style: { maxWidth: 100 },
          })}
          {renderFormInput("name_Ar")}
          {renderFormInput("name_En")}
          {renderFormInput("countryId", Enums.ControlType.AutoSearch)}
          {renderFormInput("notes")}
          {renderFormInput("notActive", Enums.ControlType.CheckBox)}
        </Grid>
      </CardContent>
    </Card>
  );

  return (
    <React.Fragment>
      {renderFormHeader()}
      {!values.id && indexColumns && !!indexColumns.length && (
        <AMIndexList
          key={indexColumns.length}
          columns={indexColumns}
          getAll={defaultService.getAll}
        />
      )}
      {!!values.id && (
        <Grid container spacing={4}>
          <Grid item xs={12}>
            {mainData}
          </Grid>
        </Grid>
      )}
    </React.Fragment>
  );
}

export default Destination;
